module.exports = __webpack_public_path__ + "img/sld_aux_transformer_h_dark.6fcbcbf6.svg";